export default {
  "betActivity.thead.index": "#序号",
  "betActivity.thead.loopMethod": "循环方式",
  "betActivity.thead.isTimeLimit": "是否限时",
  "betActivity.thead.specifiedTime": "指定时间",
  "betActivity.thead.selectDayOfWeek": "选择周期",
  "betActivity.thead.selectDay": "选择日期",
  "betActivity.thead.betProviderType": "有效打码平台",
  "betActivity.thead.betProviderValues": "平台选择",
  "betActivity.thead.betGameTypeValues": "游戏类型选择",
  "betActivity.thead.getBonusType": "领取次数",
  "betActivity.thead.betAmount": "有效投注额",
  "betActivity.thead.bonusAmount": "奖励金额",
  "betActivity.thead.rollover": "流水倍数",
  "betActivity.thead.action": "操作",
  "betActivity.add": "添加",
  "betActivity.delete": "删除",
};
